import {Directive, ElementRef, Input, HostListener, Renderer, Renderer2, forwardRef, Provider} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {RequestsService} from '../services/requests.service';
import {AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS} from '@angular/forms';


@Directive({
  selector: '[CheckBarcode]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS,
    useExisting: forwardRef(() => CheckBarcodeDirective), multi: true
  }
  ]
})
export class CheckBarcodeDirective implements AsyncValidator {
  @Input('id') id: number;
  @Input('type') type: string;
  response;

  constructor(public el: ElementRef, public re: Renderer2, private requestsService: RequestsService) {
  }

  validate(c: AbstractControl) {
    let body = new HttpParams()
      .set('item_barcode', c.value)
      .set('item_id', String(this.id ? this.id : ''));
    return new Promise(resolve =>
      this.requestsService.postRequest('pos/items/checkBarcode', body).subscribe(
        (response) => {
          this.response = response['result_type'];
          if (this.response === 'Error') {
            resolve(null);
          } else if (this.response === 'Success') {
            resolve({CheckBarcode: true});
          }
        }
      )
    );
  }

  // validate(c: AbstractControl): any {
  //   this.barcodeService(c.value);
  //   if (this.response == 'Error') {
  //     console.log('native element if->', this.el.nativeElement);
  //     return true;
  //   }
  //   else {
  //     console.log('native element else->', this.el);
  //     return false;
  //   }
  //
  // }

  barcodeService(barcode) {
    let body = new HttpParams()
      .set('item_barcode', barcode)
      .set('type', 'variant');
    this.requestsService.postRequest('pos/items/checkBarcode', body).subscribe(
      (response) => {
        this.response = response['result_type'];
        console.log('response=-0>', this.response);
        if (this.response == 'Error') {
          console.log('native element if->', this.el.nativeElement);
        } else {
          console.log('native element else->', this.el);
          this.el.nativeElement.value = null;
        }
      }
    );
  }

}
